import * as React from "react";

import { User } from "../../types";

export interface UserDisplayNameProps {
  user?: User;
}

function UserDisplayName({ user }: UserDisplayNameProps) {
  const { name } = user?.profile || {};

  return <>{name}</>;
}

export default UserDisplayName;
